import React from 'react';
import { Result, Button } from 'antd';

const NotFound = () => {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Esta página no existe"
      extra={
        <Button type="link" href="/">
          Ir a inicio
        </Button>
      }
    />
  );
};

export default NotFound;
